import React from 'react';
import PropTypes from 'prop-types';

import { startCase as _startCase } from 'lodash';
import { ConfirmDelete, Typography } from '@metarouter-private/mr-mui';

export default function DeleteParameter({ operationToDelete, playbookState, setOperationToDelete, navState }) {
  const [section, type] = operationToDelete._path.split('.');

  const handleConfirm = () => {
    playbookState.deleteParameter(section, operationToDelete.event, type, operationToDelete.opId);
    navState.setTransformation(null);
    setOperationToDelete(null);
  };

  const handleClose = () => {
    setOperationToDelete(null);
  };

  return (
    <ConfirmDelete
      open={true}
      onClose={handleClose}
      title="Delete Parameters"
      message={
        <Typography>
          Delete <strong>{operationToDelete.outputKey || operationToDelete.expressionName}</strong> from{' '}
          {operationToDelete.event || `${_startCase(section)} Parameters`}?
        </Typography>
      }
      onConfirm={handleConfirm}
      ConfirmProps={{ 'data-test-id': 'ConfirmDeleteParameter' }}
    />
  );
}

DeleteParameter.propTypes = {
  operationToDelete: PropTypes.object.isRequired,
  playbookState: PropTypes.object.isRequired,
  setOperationToDelete: PropTypes.func.isRequired,
  navState: PropTypes.object.isRequired,
};
